import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-restore-student-support-article',
    template: `
        <ng-container i18n="@@support.articles.restoreStudent">
            <p>An account of a student that has been deleted can still be restored within 14 days. After 14 days, the account will be anonymized and cannot be recovered.</p>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/students">Students Overview</a>.</span>
                </li>
                <li>
                    <span>
                        If students have been deleted in the past 14 days, an extra button will appear to view these students.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/restoreStudentBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        A window appears with all recently deleted students. In the <strong>Info</strong> column you can see on which date and by which administrator the student was deleted.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/deletedStudents.png" />
                    </span>
                </li>
                <li>
                    <span>Click <strong>Restore</strong> next to a student to restore their account.</span>
                </li>
            </ol>
        </ng-container>
    `
})
export class RestoreStudentSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
